import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    margin: theme.spacing(-1.375, 0, -1.375, 0),
  },
  radioLabel: {
    marginBottom: theme.spacing(2),
  },
  radioContainer: {
    margin: theme.spacing(-1.375, 0, 0, 0),
  },
  subTerms: {
    margin: theme.spacing(-0.625, 0, 0, 3),
  },
  terms: {
    margin: theme.spacing(0.125, 0, 1.375, 1),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
}))
